import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"width":"calc(100% - 60px)"},
  class: "fl with_white_bg pad10 rad5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { class: "fs18 mt12" }
const _hoisted_4 = { class: "fs11" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!

  return (_ctx.showInstantRoomContent)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`InstantRoomContent w100 rad20 ${_ctx.bgColor || `llgreyBg`} mb10 fw600 pad10`)
      }, [
        (_ctx.owner && !_ctx.hideFromParams)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`${_ctx.isSP ? `w100 mb10` : `w60 fl`} `)
            }, [
              _createVNode(_component_UserIcon, {
                member: _ctx.owner,
                width: _ctx.isSP ? 38 : 45,
                canEdit: false,
                updateSelf: false,
                showTooltip: false,
                class: _normalizeClass(`fl mr10`),
                style: `border-radius: 50%;`
              }, null, 8, ["member", "width"]),
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.buttonDescription), 1),
              _hoisted_2
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(`${_ctx.isSP ? `pad1 mc` : `fr w30`} pointer rad14 centered gradBlueBg hoverGreyBg ${
                _ctx.hideShadow ? `` : `popUpShadow`
            }`),
          style: {"width":"248px","height":"58px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickInstantButton && _ctx.clickInstantButton(...args)))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.buttonTitle), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.buttonSmallText), 1)
        ], 2),
        _hoisted_5
      ], 2))
    : _createCommentVNode("", true)
}